export const EFFECTIVE_EVENT = "EFFECTIVE_EVENT";
